export default __webpack_public_path__ + "static/media/trr-drink-bottle-crookedstaveipa.10b27e3c.png";